import type { ParsedQs } from 'qs';
import { searchFormValuesFromQueryString } from './searchFormValuesFromQueryString';
import { searchUidFromFormValues } from './searchUidFromFormValues';

export const searchUidFromUrlParams = (params: ParsedQs) => {
    const values = searchFormValuesFromQueryString(params);
    return searchUidFromFormValues(values);
};
